module.exports = __webpack_public_path__ + "static/media/BillingPortal.5090de12.png";